export default {
    nav: {
        subject: "通知内容"
    }
}
